module.exports = __webpack_public_path__ + "img/oracle.c6e9e7fa.png";